import api from './api';

export const authService = {
  async login(username, password) {
    console.log('🔐 Tentando fazer login:', { username, password: '***' });
    try {
      const response = await api.post('/api/auth/login', {
        username,
        password
      });
      console.log('✅ Resposta do login:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro no login:', error);
      console.error('❌ Detalhes do erro:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  },

  async validateToken(token) {
    try {
      const response = await api.get('/api/auth/validate', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data.user;
    } catch (error) {
      console.error('❌ Erro ao validar token:', error);
      throw error;
    }
  },

  async logout() {
    try {
      await api.post('/api/auth/logout');
    } catch (error) {
      console.log('Erro no logout:', error);
    }
  }
};
